module.exports = __webpack_public_path__ + "static/media/animated_madjid.7f437a2e.png";